<template>
    <div class="inline-flex flex-col align-middle p-2 rounded-md border shadow h-44 w-80 justify-center items-start overflow-hidden">
        <label class="text-gray-400 font-bold text-sm flex-none">
            Tài xế
        </label>
        <div
            v-if="drivers.length"
            class="flex-1 w-full overflow-auto pr-1">
            <template
                v-for="(driver, index) in drivers"
                :key="index">
                <div
                    v-if="driver"
                    class="flex-1 flex flex-col justify-center items-start w-full mb-2 p-1 rounded"
                    :class="{ border: drivers.length > 1 }">
                    <div class="flex justify-start items-center w-full overflow-hidden">
                        <hts-user
                            :id="driver.companyUser?._id"
                            size="small"
                            class="flex-none" />
                        <div class="flex-1 px-1 truncate">
                            <div class="truncate text-gray-600 font-bold text-lg">
                                {{ driver.fullName }}
                            </div>
                            <driver-status
                                v-if="driver.status"
                                :status="driver.status" />
                        </div>
                    </div>
                    <div class="w-full text-sm pl-3 flex items-center">
                        <span class="flex-none">
                            <hts-icons icon-name="hi-phone-icon" />
                        </span>
                        <span class="flex-1 truncate">
                            ({{ driver.phone?.code }}) {{ driver.phone?.phone }}
                        </span>
                    </div>
                </div>
                <div
                    v-else
                    class="flex flex-col justify-center items-start w-full rounded mb-2 p-1">
                    Chưa có thông tin
                </div>
            </template>
        </div>
        <div v-else>
            Chưa có thông tin
        </div>
    </div>
</template>
<script lang="ts" setup>
import DriverStatus from '../journey-info/driver-status.vue'
const props = defineProps({
  drivers: {
    type: Array<any>,
    required: true
  }
})

const emits = defineEmits(['modify', 'skipped', 'change'])
const { drivers } = toRefs(props)

onMounted(() => {})
</script>
